/*
 * Copyright 2025 coze-dev Authors
 * Modifications Copyright 2026 Bytefinger Technology (HK) Co., Limited (https://bytefinger.ai).
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type ReactNode, createContext } from 'react';

import {
  type IChatInputProps,
  type InputNativeCallbacks,
} from '@adp-common/chat-uikit-shared';

type OnBeforeSubmit = IChatInputProps['onBeforeSubmit'];

export interface ChatInputProps
  extends Pick<IChatInputProps, 'leftActions' | 'rightSlot'> {
  /**
   * {@link OnBeforeSubmit}
   */
  onBeforeSubmit?: OnBeforeSubmit;
  submitClearInput?: boolean;
  /**
   * @deprecated
   */
  addonBottom?: ReactNode;
  uploadButtonTooltipContent?: ReactNode;
  wrapperClassName?: string;
  inputNativeCallbacks?: InputNativeCallbacks;
  safeAreaClassName?: string;
  getContainer?: () => HTMLElement;
}

export const ChatInputPropsContext = createContext<ChatInputProps>({});
